module.exports = __webpack_public_path__ + "static/img/Aivi-Luik.3123143.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aivi-Luik.jpg
// module id = csu+
// module chunks = 0